import React from 'react';
import AssistantIcon from '@material-ui/icons/Assistant';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
} from 'candy-commons-components';
import constants from 'candy-commons/constants';
import {
    Create,
    SimpleForm,
    TextInput,
    useTranslate,
} from 'react-admin';

const EcoEvents = constants.EcoEvents;
const EnergyProvider = (props) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.energy-provider.name'),
            url: 'energy-provider',
            icon: <AssistantIcon />,
        },
        {
            text: translation('resources.energy-provider.create.name'),
            url: '',
        },
    ];
    
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Create {...props}>
                <SimpleForm redirect="list">
                        <ContainerFieldsList>
                            <TextInput
                                source="energyProviderKey"
                                label="Energy Provider"
                                required
                            />
                            <TextInput
                                source="deepLink"
                                label="Deep Link"
                            />
                            <TextInput
                                source="appName"
                                label="App Name"
                            />
                        </ContainerFieldsList>
                </SimpleForm>
            </Create>
        </>
    );
};
export default EnergyProvider;
